module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/notifications/notifications.component.scss
// module id = 581
// module chunks = 1